declare const window: any;

window.XLSX = require("xlsx");

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { sync } from "vuex-router-sync";
import "./registerServiceWorker";
import "./sass/app.scss";
import Directives from "./directives";
import ToggleButton from "vue-js-toggle-button";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Vuebar from "vuebar";
import Tooltip from "v-tooltip";

Vue.use(ToggleButton);
Vue.use(Directives);
Vue.use(Vuebar);
Vue.use(Tooltip);

Vue.config.productionTip = false;

sync(store, router);

Vue.component("AppHeader", () =>
  import(/* webpackChunkName: "header" */ "@/components/Header.vue")
);
Vue.component("AppFooter", () =>
  import(/* webpackChunkName: "footer" */ "@/components/Footer.vue")
);
Vue.component("AppSpinner", () =>
  import(/* webpackChunkName: "spinner" */ "@/components/Spinner.vue")
);
Vue.component("AppButton", () =>
  import(/* webpackChunkName: "button" */ "@/components/Button.vue")
);
Vue.component("AppInput", () =>
  import(/* webpackChunkName: "input" */ "@/components/Input.vue")
);
Vue.component("AppTextarea", () =>
  import(/* webpackChunkName: "textarea" */ "@/components/Textarea.vue")
);
Vue.component("UnconfirmedEmail", () =>
  import(
    /* webpackChunkName: "unconfirmed-email" */ "@/components/UnconfirmedEmail.vue"
  )
);
Vue.component("AppModal", () =>
  import(/* webpackChunkName: "modal" */ "@/components/Modal.vue")
);
Vue.component("AccessTimeIcon", () =>
  import(/* webpackChunkName: "access-time-icon" */ "@/icons/AccessTime.vue")
);
Vue.component("VpnKeyIcon", () =>
  import(/* webpackChunkName: "vpn-key-icon" */ "@/icons/VpnKey.vue")
);
Vue.component("FileCopyIcon", () =>
  import(/* webpackChunkName: "file-copy-icon" */ "@/icons/FileCopy.vue")
);
Vue.component("EditIcon", () =>
  import(/* webpackChunkName: "edit-icon" */ "@/icons/Edit.vue")
);
Vue.component("DeleteIcon", () =>
  import(/* webpackChunkName: "delete-icon" */ "@/icons/DeleteOutlined.vue")
);
Vue.component("CheckCircleIcon", () =>
  import(
    /* webpackChunkName: "check-circle-icon" */ "@/icons/CheckCircleOutlined.vue"
  )
);
Vue.component("CancelIcon", () =>
  import(/* webpackChunkName: "check-circle-icon" */ "@/icons/Cancel.vue")
);
Vue.component("AppsIcon", () =>
  import(/* webpackChunkName: "apps-icon" */ "@/icons/Apps.vue")
);
Vue.component("AddCircleIcon", () =>
  import(/* webpackChunkName: "add-circle-icon" */ "@/icons/AddCircle.vue")
);
Vue.component("AddIcon", () =>
  import(/* webpackChunkName: "add-icon" */ "@/icons/Add.vue")
);
Vue.component("MoreHorizontalIcon", () =>
  import(
    /* webpackChunkname: "more-horizontal-icon" */ "@/icons/MoreHorizontal.vue"
  )
);
Vue.component("ArrowDropdownIcon", () =>
  import(
    /* webpackChunkname: "arrow-dropdown-icon" */ "@/icons/ArrowDropdown.vue"
  )
);
Vue.component("PersonIcon", () =>
  import(/* webpackChunkname: "person-icon" */ "@/icons/Person.vue")
);
Vue.component("LockIcon", () =>
  import(/* webpackChunkname: "lock-icon" */ "@/icons/Lock.vue")
);
Vue.component("SettingsIcon", () =>
  import(/* webpackChunkname: "settings-icon" */ "@/icons/Settings.vue")
);
Vue.component("ExitToAppIcon", () =>
  import(/* webpackChunkname: "exit-to-app-icon" */ "@/icons/ExitToApp.vue")
);
Vue.component("DashboardIcon", () =>
  import(/* webpackChunkname: "dashboard-icon" */ "@/icons/Dashboard.vue")
);
Vue.component("Checkbox", () =>
  import(/* webpackChunkName: "checkbox" */ "@/components/Checkbox.vue")
);
Vue.component("AppSelect", () =>
  import(/* webpackChunkName: "select" */ "@/components/Select.vue")
);
Vue.component("Radio", () =>
  import(/* webpackChunkName: "radio" */ "@/components/Radio.vue")
);
Vue.component("Clipboard", () =>
  import(/* webpackChunkName: "clipboard" */ "@/components/Clipboard.vue")
);
Vue.component("Pagination", () =>
  import(/* webpackChunkName: "pagination" */ "@/components/Pagination.vue")
);
Vue.component("AppSearch", () =>
  import(/* webpackChunkName: "search-input" */ "@/components/Search.vue")
);
Vue.component("Popper", () =>
  import(/* webpackChunkName: "popper" */ "@/components/Popper.vue")
);
Vue.component("Dropdown", () =>
  import(/* webpackChunkName: "dropdown" */ "@/components/Dropdown.vue")
);
Vue.component("AppTable", () =>
  import(/* webpackChunkName: "table" */ "@/components/Table.vue")
);
Vue.component("DataTable", () =>
  import(/* webpackChunkName: "table" */ "@/components/DataTable.vue")
);
Vue.component("Tabulator", () =>
  import(/* webpackChunkName: "tabulator" */ "@/components/Tabulator.vue")
);

Vue.prototype.$swal = Swal.mixin({
  reverseButtons: true
});

Vue.prototype.$toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
